import { languageMap } from ".."

languageMap.dockerfile = languageMap.docker = {
	comments: {
		line: "#",
	},
}
